import React from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import DownloadFileHelper from "../../components/download-file-helper";


export default function PaymentDetails({payment, callback}){
  if (payment) return(
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5} >
        <Typography variant={'h5'} color={'primary'}>
          Payment details
        </Typography>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Country
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.country}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Transaction number
          </Typography>

          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.transactionNumber}
          </Typography>
        </Stack>
        {/* <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Beneficiary’s full name
          </Typography>

          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.beneficiaryFullname}

          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Beneficiary’s address
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.beneficiaryAddress}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Beneficiary’s BIC
          </Typography>

          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {payment?.beneficiaryBIC}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            IBAN
          </Typography>

          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.IBAN}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Beneficiary’s Country/Region
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.BeneficiaryCountry}
          </Typography>
        </Stack> */}
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Recipient's Name
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.recipientsName}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Recipient's Address
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.recipientsAddress}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Account Type
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.accountType}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Bank Name
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.bankName}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Account Title
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.accountTitle}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Account number
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.accountNumber}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Amount
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            ${payment?.amount}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            BIC Code
          </Typography>
          <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
            {payment?.BICSwiftCode}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
            Payment slip/receipt
          </Typography>
          <Typography variant={'body1'} color={'primary'} sx={{maxWidth: 300, textDecoration: 'underline', cursor:'pointer'}} noWrap={true} onClick={() => DownloadFileHelper(payment?.attachment)}>
            {  payment?.attachment.split('/')[ payment?.attachment.split('/').length -1]}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={3} justifyContent="center"
               alignItems="center">
          <Button variant={'contained'} color={'primary'} onClick={() => callback(false)}>Go back</Button>

        </Stack>
      </Stack>
    </Container>
  )
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}></Container>
  )
}